<div class="wrapper">
  <a [project-route]="['history/statuses']" style="position: absolute; margin-left: 15px;" mat-button>
    <mat-icon style="margin-right: 5px;">arrow_back</mat-icon>
    <mat-label>{{ 'HISTORY.RECONCILIATION.status_history' | translate }}</mat-label>
  </a>

  <div class="page-head">
    <app-heading [title]="$safeNavigationMigration(statusChange.whoChange?.fullName)"
      [subtitle]="$safeNavigationMigration(statusChange.whoChange?.username)"
      hAlign="right">
    </app-heading>

    <app-date [date]="statusChange.createdAt"></app-date>
  </div>

  @if (statuses$ | async; as statuses) {
    <nav [tabPanel]="tabPanel" mat-tab-nav-bar>
      @for (group of statusChange.groups; track group) {
        <a
          [project-route]="['history/statuses', statusChange.id, group.id]"
          [active]="statusChangeId === group.id"
          class="change"
          mat-tab-link
          tab-highlight>
          <div class="from" [matTooltip]="$safeNavigationMigration(statuses[group.fromStatusId]?.name)">
            {{ statuses[group.fromStatusId]?.name || ('COMMON.not_found' | translate) }}
          </div>
          <div class="arrow-wrapper">
            <div class="arrow">
              <span class="up"></span>
              <span class="down"></span>
            </div>
            <span>{{ group.count }}</span>
          </div>
          <div class="to" [matTooltip]="$safeNavigationMigration(statuses[group.toStatusId]?.name)">
            {{ statuses[group.toStatusId]?.name || ('COMMON.not_found' | translate) }}
          </div>
        </a>
      }
    </nav>
  }

  <mat-tab-nav-panel #tabPanel>
    @if (!statusChangeId) {
      <app-not-found [text]="'HISTORY.RECONCILIATION.select_status_group' | translate"></app-not-found>
    }

    <router-outlet></router-outlet>
  </mat-tab-nav-panel>

</div>
